const DataGalleryTestimonial = [
  {
    id: 1,
    src: 'pic1.jpg',
	title:"RAHUL SHARMA",
	designation:"Business Man",
	description:"A good school cares for its students, studying and knowing the needs, interests and strengths of its students and motivates them to learn and grow. ",
    alt: "Business Man"
  },
  {
    id: 2,
    src: 'pic2.jpg',
	title:"RAHUL GURJAR",
	designation:"Business Man",
	description:"My child have studied from this school from class nursery to 12th. They are very successful and I am a proud father. I thank this School to inculcate the values & ethics in them.",
    alt: "Business Man"
  },{
    id: 3,
    src: 'pic1.jpg',
	title:"HAJARI MEENA",
	designation:"Advocate",
	description:"I attended this school nearly a decade ago and have only great things to say about my experience.",
    alt: "Advocate"
  },{
    id: 4,
    src: 'pic2.jpg',
	title:"NEPAL SINGH",
	designation:"Advocate",
	description:"My children LOVE this school – from the teachers to the students to the challenging curriculum.",
    alt: "Advocate"
  }
];

export default DataGalleryTestimonial;